import { render, staticRenderFns } from "./responsavel.vue?vue&type=template&id=697aa8bd&scoped=true"
import script from "./responsavel.vue?vue&type=script&lang=js"
export * from "./responsavel.vue?vue&type=script&lang=js"
import style0 from "./responsavel.vue?vue&type=style&index=0&id=697aa8bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697aa8bd",
  null
  
)

export default component.exports